import { ErrorScreen } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { Profile as ProfileApp } from '@datapad/profile';
import type React from 'react';

/**
 * Profile app wrapper.
 *
 * @remarks
 * The Profile app displays the current user's session character.
 * The character is determined by the AppContext - players can change their
 * session character via the datapad menu.
 */
export function Profile(): React.ReactElement {
	const appContext = useAppContext();

	// Only players and GMs can view profiles
	if (appContext.getEffectivePermissionLevel() === 'guest') {
		return (
			<ErrorScreen
				textLines={['You must be logged in as a player to view your character profile.']}
			/>
		);
	}

	// Get the character from the app context
	// Type guard: check if context has a character property (non-guest contexts)
	if (!('character' in appContext) || appContext.character === undefined) {
		return (
			<ErrorScreen
				textLines={[
					'No character selected.',
					'Please select a character from the main menu.',
				]}
			/>
		);
	}

	const characterRef = appContext.character;

	const character = appContext.getCharacter(characterRef);

	return <ProfileApp character={character} />;
}
